import React, { useState } from "react";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import InputMask from "react-input-mask";
import "react-toastify/dist/ReactToastify.css";
import "./style.scss";
import Swal from "sweetalert2";
import { FaAngleRight } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { ptBR } from "date-fns/locale";
import { FiCalendar } from "react-icons/fi";

import "react-datepicker/dist/react-datepicker.css";



function Cadastro_motorista() {
  const [form, setForm] = useState({});
  const [cpfError, setCpfError] = useState("");
  const [pisError, setPisError] = useState("");
  const [cnpjError, setCnpjError] = useState("");
  const [cnhError, setCnhError] = useState("");
  const [dataVencimentoError, setDataVencimentoError] = useState("");
  const [dataNascimentoError, setDataNascimentoError] = useState("");
  const voltar = useNavigate();
  const [cpfExistente, setCpfExistente] = useState(false);
  const [verificandoCpf, setVerificandoCpf] = useState(false);

  //MAXIMO DE CARACTERS PARA NOME COMPLETO
  const MAX_NOME = 30;
  //MAXIMO DE CARACTERS PARA APELDIAO
  const MAX_APELIDO = 30


  // -------------------------------// LÓGICA CNH-----------------------------------------------------------------
  const [categoriaError, setCategoriaError] = useState("");
  //CNH OBRIGATORIA 
  const isCnhObrigatoria = form.tipo === "m";
  //VALIDAÇÃO CNH 
  const MAX_CNH = 11;
  //CATEGORIA CNH
  const categoriasCNH = ["A", "B", "AB", "C", "D", "E"];


  const sanitizeCnh = (value) => value.replace(/\D/g, "").slice(0, MAX_CNH);

  const validateCnh = (value) => {
    if (!value) return "";
    if (value.length !== MAX_CNH) return "CNH deve ter exatamente 11 números";
    return "";
  }
  const handleCnhChange = (e) => {
    const value = sanitizeCnh(e.target.value);

    handleChange({
      target: { name: "num_cnh", value },
    });

    setCnhError(validateCnh(value));
  };

  const sanitizeCategoria = (value) =>
    value.replace(/[^ABCDE]/gi, "").toUpperCase();

  const validateCategoria = (value, isObrigatoria) => {
    if (!isObrigatoria) return "";
    if (!value) return "Categoria é obrigatória para motoristas";
    return "";
  };
  const handleCategoriaChange = (e) => {
    const value = sanitizeCategoria(e.target.value);

    handleChange({
      target: { name: "categoria", value },
    });

    setCategoriaError(
      validateCategoria(value, isCnhObrigatoria)
    );
  };

  useEffect(() => {
    if (form.tipo === "a") {
      setForm(prev => ({
        ...prev,
        num_cnh: "",
        categoria: "",
        data_vencimento: null,
      }));

      setCnhError("");
      setCategoriaError("");
    }
  }, [form.tipo]);
  //-----------------------------------------------------------------------------------------




  //VALIDAÇÃO DATA NASCIMENTO
  useEffect(() => {
    if (dataNascimentoError) {
      Swal.fire({
        icon: "error",
        title: "Data de nascimento inválida",
        text: dataNascimentoError,
        confirmButtonText: "Entendi",
      });
    }
  }, [dataNascimentoError]);

  const handleNascimentoValidate = (e) => {
    const value = e.target.value;
    handleChange(e);

    if (!value) {
      setDataNascimentoError("");
      return;
    }

    const hoje = new Date();
    const nascimento = new Date(value);

    hoje.setHours(0, 0, 0, 0);
    nascimento.setHours(0, 0, 0, 0);

    if (nascimento >= hoje) {
      setDataNascimentoError("Data de nascimento inválida");
      return;
    }

    const idadeMinima = new Date(hoje);
    idadeMinima.setFullYear(hoje.getFullYear() - 18);

    if (nascimento > idadeMinima) {
      setDataNascimentoError("Não é possível cadastrar menores de idade!");
    } else {
      setDataNascimentoError("");
    }
  };


  //------------------------------------------------------------------------------



























  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));

    if (name === "cpf") setCpfError("");
    if (name === "num_pis") setPisError("");
    if (name === "cnpj") setCnpjError("");
    if (name === "num_cnh") setCnhError("");






  };

  //VALIDAÇÃO DE CPF
  function validarCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf.length !== 11) return false;
    if (/^(\d)\1+$/.test(cpf)) return false;

    let soma = 0;
    for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
    let resto = 11 - (soma % 11);
    let digito1 = resto === 10 || resto === 11 ? 0 : resto;

    soma = 0;
    for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
    resto = 11 - (soma % 11);
    let digito2 = resto === 10 || resto === 11 ? 0 : resto;

    return (
      digito1 === parseInt(cpf.charAt(9)) &&
      digito2 === parseInt(cpf.charAt(10))
    );
  }

  //ENVIANDO FORMULARIO SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasError = false;

    // CPF
    if (form.cpf && !validarCPF(form.cpf)) {
      setCpfError("CPF inválido");
      hasError = true;
    }

    // REGRA PIS ↔ CNPJ
    if (form.num_pis && !form.cnpj) {
      setCnpjError("CNPJ obrigatório quando PIS está preenchido");
      hasError = true;
    }

    if (form.cnpj && !form.num_pis) {
      setPisError("PIS obrigatório quando CNPJ está preenchido");
      hasError = true;
    }

    // CNH obrigatória
    if (form.tipo === "m" && !form.num_cnh) {
      Swal.fire({
        icon: "error",
        title: "Erro no cadastro",
        text: "CNH é obrigatória para motoristas",
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#ef4444",
      });
      return;
    }

    // CNH inválida
    if (cnhError) {
      Swal.fire({
        icon: "error",
        title: "Erro no cadastro",
        text: cnhError,
        background: "#0f172a",
        color: "#fff",
        confirmButtonColor: "#ef4444",
      });
      return;
    }

    if (hasError) return;

    const numeroCartaoLimpo =
      (form.num_cartao_acesso || "").replace(/^0+/, "");

    const dados = {
      ...form,
      num_cartao_acesso: numeroCartaoLimpo,
      criado_por: localStorage.getItem("clientID"),
      id_cliente: localStorage.getItem("id"),
    };

    await Swal.fire({
      title: "Cadastrando colaborador...",
      background: "#0f172a",
      color: "#fff",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,

      html: `
      <div style="margin-top:15px;text-align:center;">

        <div style="
          width:58px;
          height:58px;
          margin:auto;
          border:4px solid rgba(255,255,255,.08);
          border-top:4px solid #38bdf8;
          border-right:4px solid #0ea5e9;
          border-radius:50%;
          animation:spinSwal .8s linear infinite;
        "></div>

        <p style="
          margin-top:18px;
          color:#94a3b8;
          font-size:14px;
        ">
          Salvando informações...
        </p>

      </div>

      <style>
        @keyframes spinSwal{
          0%{transform:rotate(0deg)}
          100%{transform:rotate(360deg)}
        }
      </style>
    `,

      didOpen: async () => {
        const inicio = Date.now();

        try {
          await api.post("/motorista", dados);

          // TEMPO MÍNIMO LOADER
          const tempoMinimo = 1500;
          const tempoPassado = Date.now() - inicio;

          if (tempoPassado < tempoMinimo) {
            await new Promise((resolve) =>
              setTimeout(resolve, tempoMinimo - tempoPassado)
            );
          }

          // fecha loader
          Swal.close();

          // limpa form
          document.getElementById("myform").reset();

          // navega primeiro
          navigate(-1);

          // popup sucesso na nova rota
          setTimeout(() => {
            Swal.fire({
              title: "Cadastrado com sucesso!",
              icon: "success",
              background: "#0f172a",
              color: "#fff",
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false,
            });
          }, 220);


        } catch (error) {
          Swal.close();

          if (error.response?.status === 409) {
            Swal.fire({
              title: "CPF já cadastrado!",
              text: "Já existe um colaborador com este CPF.",
              icon: "warning",
              background: "#0f172a",
              color: "#fff",
              confirmButtonColor: "#f59e0b",
            });
            return;
          }

          if (error.response?.status === 400) {
            Swal.fire({
              title: "Atenção",
              text: error.response.data.error,
              icon: "warning",
              background: "#0f172a",
              color: "#fff",
              confirmButtonColor: "#f59e0b",
            });
            return;
          }

          Swal.fire({
            title: "Erro ao cadastrar",
            text: "Tente novamente.",
            icon: "error",
            background: "#0f172a",
            color: "#fff",
            confirmButtonColor: "#ef4444",
          });
        }
      },
    });
  };
  //VERIFICAÇÃO ANTES DE ENVIAR O FORM
  const canSubmit =
    !cpfError &&
    !pisError &&
    !cnpjError &&
    !cnhError &&
    !categoriaError &&
    !dataNascimentoError &&
    !dataVencimentoError &&
    !cpfExistente &&
    !verificandoCpf;

  //VERIFICAÇÃO SE JA EXISTISTE O MESMO CPF NO BANCO


  return (
    <>
      <ToastContainer />

      <div className="cadastro-motorista-container">

        <div className="cadastro-motorista-card">

          {/* =====================================================
            HEADER
        ===================================================== */}

          <div className="cadastro-motorista-header">

            <div className="cadastro-header-content">

              <div className="cadastro-header-line"></div>

              <div>

                <h4 className="cadastro-enfermeiro-title">
                  Cadastro de Motorista
                </h4>

                <span className="cadastro-enfermeiro-subtitle">
                  Preencha os dados para cadastrar um novo motorista.
                </span>

              </div>

            </div>


            {/* BOTÃO FECHAR */}

            <button
              type="button"
              className="cadastro-close-btn"
              onClick={() => voltar("/maps/motorista")}
              title="Fechar"
            >
              <span>×</span>
            </button>

          </div>


          {/* =====================================================
            BODY
        ===================================================== */}

          <div className="cadastro-enfermeiro-body cadastro-motorista-body">

            <form
              id="myform"
              onSubmit={handleSubmit}
              autoComplete="off"
            >

              {/* =================================================
                CAMPOS
            ================================================= */}

              <div className="cadastro-fields">


                {/* =================================================
                  NOME
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Nome Completo

                    <span className="required">
                      *
                    </span>

                  </label>

                  <input
                    type="text"
                    name="nome"
                    required
                    placeholder="Digite o nome completo"
                    className="cadastro-input"
                    onChange={handleChange}
                    maxLength={30}
                    value={form.nome || ""}
                    autoComplete="off"
                    spellCheck={false}
                  />

                  <div className="cadastro-input-footer">

                    <span>
                      Nome do motorista
                    </span>

                    <span>
                      {(form.nome || "").length}/30
                    </span>

                  </div>

                </div>


                {/* =================================================
                  APELIDO
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Apelido

                    <span className="required">
                      *
                    </span>

                  </label>

                  <input
                    type="text"
                    name="apelido"
                    placeholder="Primeiro e segundo nome"
                    className="cadastro-input"
                    onChange={handleChange}
                    required
                    maxLength={25}
                    value={form.apelido || ""}
                    autoComplete="off"
                    spellCheck={false}
                  />

                  <div className="cadastro-input-footer">

                    <span>
                      Apelido do motorista
                    </span>

                    <span>
                      {(form.apelido || "").length}/25
                    </span>

                  </div>

                </div>


                {/* =================================================
                  TIPO
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Tipo

                    <span className="required">
                      *
                    </span>

                  </label>

                  <select
                    className="cadastro-input"
                    name="tipo"
                    onChange={handleChange}
                    required
                    value={form.tipo || ""}
                    autoComplete="off"
                  >

                    <option value="">
                      Selecione uma opção
                    </option>

                    <option value="m">
                      Motorista
                    </option>

                    <option value="a">
                      Acompanhante
                    </option>

                  </select>

                </div>


                {/* =================================================
                  DATA NASCIMENTO
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Data de nascimento

                    <span className="required">
                      *
                    </span>

                  </label>

                  <div className="custom-date-wrapper">

                    <DatePicker
                      locale={ptBR}

                      placeholderText="DD/MM/AAAA"

                      maxDate={new Date()}

                      popperPlacement="bottom-start"

                      portalId="root"

                      selected={
                        form.data_nascimento
                          ? new Date(
                            `${form.data_nascimento}T00:00:00`
                          )
                          : null
                      }

                      onChange={(date) => {

                        if (!date) {

                          handleNascimentoValidate({
                            target: {
                              name: "data_nascimento",
                              value: "",
                            },
                          });

                          return;
                        }

                        const ano =
                          date.getFullYear();

                        const mes =
                          String(
                            date.getMonth() + 1
                          ).padStart(2, "0");

                        const dia =
                          String(
                            date.getDate()
                          ).padStart(2, "0");

                        const dataFormatada =
                          `${ano}-${mes}-${dia}`;

                        handleNascimentoValidate({
                          target: {
                            name: "data_nascimento",
                            value: dataFormatada,
                          },
                        });

                      }}

                      dateFormat="dd/MM/yyyy"

                      showMonthDropdown

                      showYearDropdown

                      dropdownMode="select"

                      autoComplete="off"

                      customInput={
                        <InputMask
                          mask="99/99/9999"
                          placeholder="DD/MM/AAAA"
                          className={`cadastro-input custom-date-input ${dataNascimentoError
                              ? "cadastro-input-error"
                              : ""
                            }`}
                          autoComplete="off"
                          spellCheck={false}
                        />
                      }

                    />

                    <FiCalendar className="custom-date-icon" />

                  </div>


                  {dataNascimentoError && (

                    <div className="invalid-feedback">
                      {dataNascimentoError}
                    </div>

                  )}

                </div>


                {/* =================================================
                  CPF
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    CPF

                    <span className="required">
                      *
                    </span>

                  </label>

                  <InputMask
                    mask="999.999.999-99"
                    placeholder="000.000.000-00"
                    required
                    type="text"
                    name="cpf"
                    value={form.cpf || ""}
                    className={`cadastro-input ${cpfError
                        ? "cadastro-input-error"
                        : ""
                      }`}
                    autoComplete="off"
                    onChange={(e) => {

                      const value =
                        e.target.value;

                      handleChange(e);

                      const cpfLimpo =
                        value.replace(
                          /[^\d]+/g,
                          ""
                        );

                      if (
                        cpfLimpo.length === 11
                      ) {

                        const valido =
                          validarCPF(cpfLimpo);

                        setCpfError(
                          valido
                            ? ""
                            : "CPF inválido"
                        );

                      } else {

                        setCpfError(
                          "CPF incompleto"
                        );

                      }

                    }}
                    onBlur={async (e) => {

                      const cpfLimpo =
                        e.target.value.replace(
                          /\D/g,
                          ""
                        );

                      if (
                        cpfLimpo.length !== 11
                      ) {
                        return;
                      }

                      setVerificandoCpf(true);

                      try {

                        const res =
                          await api.get(
                            `/motorista/verificar-cpf/${cpfLimpo}`
                          );

                        if (res.data.existe) {

                          setCpfExistente(true);

                          await Swal.fire({

                            title:
                              "CPF já cadastrado!",

                            icon:
                              "warning",

                            background:
                              "#0f172a",

                            color:
                              "#ffffff",

                            html: `
                            <p style="
                              text-align:center;
                              margin-bottom:14px;
                              color:#cbd5e1;
                              font-size:15px;
                            ">
                              Já existe um motorista cadastrado com este CPF.
                            </p>

                            <div style="
                              border:1px solid rgba(245,158,11,0.20);
                              border-radius:12px;
                              padding:14px;
                              margin-top:10px;
                              background:rgba(255,255,255,0.03);
                              text-align:left;
                            ">

                              <p style="
                                margin:6px 0;
                                color:#fff;
                              ">

                                <b style="
                                  color:#f59e0b;
                                ">
                                  CPF:
                                </b>

                                ${e.target.value}

                              </p>

                            </div>
                          `,

                            confirmButtonText:
                              "Entendi",

                            confirmButtonColor:
                              "#f59e0b",

                          });

                        } else {

                          setCpfExistente(false);

                        }

                      } catch (error) {

                        console.log(error);

                      } finally {

                        setVerificandoCpf(false);

                      }

                    }}
                  />

                  {cpfError && (

                    <div className="invalid-feedback">
                      {cpfError}
                    </div>

                  )}

                </div>


                {/* =================================================
                  PIS
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">
                    Número do PIS
                  </label>

                  <InputMask
                    mask="999.99999.99-9"
                    placeholder="000.00000.00-0"
                    type="text"
                    name="num_pis"
                    value={form.num_pis || ""}
                    className={`cadastro-input ${pisError
                        ? "cadastro-input-error"
                        : ""
                      }`}
                    autoComplete="off"
                    onChange={(e) => {

                      handleChange(e);

                      const pis =
                        e.target.value;

                      if (
                        pis &&
                        !form.cnpj
                      ) {

                        setCnpjError(
                          "CNPJ obrigatório quando PIS está preenchido"
                        );

                      } else {

                        setCnpjError("");

                      }

                    }}
                  />

                  {pisError && (

                    <div className="invalid-feedback">
                      {pisError}
                    </div>

                  )}

                </div>


                {/* =================================================
                  CNPJ
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">
                    CNPJ
                  </label>

                  <InputMask
                    mask="99.999.999/9999-99"
                    placeholder="00.000.000/0000-00"
                    type="text"
                    name="cnpj"
                    value={form.cnpj || ""}
                    className={`cadastro-input ${cnpjError
                        ? "cadastro-input-error"
                        : ""
                      }`}
                    autoComplete="off"
                    onChange={(e) => {

                      handleChange(e);

                      const cnpj =
                        e.target.value;

                      if (
                        cnpj &&
                        !form.num_pis
                      ) {

                        setPisError(
                          "PIS obrigatório quando CNPJ está preenchido"
                        );

                      } else {

                        setPisError("");

                      }

                    }}
                  />

                  {cnpjError && (

                    <div className="invalid-feedback">
                      {cnpjError}
                    </div>

                  )}

                </div>


                {/* =================================================
                  CNH
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">
                    CNH
                  </label>

                  <input
                    type="text"
                    name="num_cnh"
                    placeholder="Número de registro"
                    className={`cadastro-input ${cnhError
                        ? "cadastro-input-error"
                        : ""
                      }`}
                    value={form.num_cnh || ""}
                    maxLength={MAX_CNH}
                    onChange={handleCnhChange}
                    onBlur={handleCnhChange}
                    autoComplete="off"
                    spellCheck={false}
                  />

                  {cnhError && (

                    <div className="invalid-feedback">
                      {cnhError}
                    </div>

                  )}

                </div>


                {/* =================================================
                  CATEGORIA CNH
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Categoria da CNH

                    {form.tipo === "m" && (

                      <span className="required">
                        *
                      </span>

                    )}

                  </label>

                  <select
                    name="categoria-cnh"
                    className="cadastro-input"
                    value={form.categoria || ""}
                    onChange={handleCategoriaChange}
                    onBlur={handleCategoriaChange}
                    required={form.tipo === "m"}
                    autoComplete="off"
                  >
                    <option value="">
                      Selecione a Categoria
                    </option>

                    <option value="A">A</option>
                    <option value="B">B</option>
                    <option value="AB">AB</option>
                    <option value="C">C</option>
                    <option value="AC">AC</option>
                    <option value="BC">BC</option>
                    <option value="D">D</option>
                    <option value="AD">AD</option>
                    <option value="BD">BD</option>
                    <option value="CD">CD</option>
                    <option value="E">E</option>
                    <option value="AE">AE</option>
                    <option value="BE">BE</option>
                    <option value="CE">CE</option>
                    <option value="DE">DE</option>
                    <option value="AB">AB</option>
                    <option value="AC">AC</option>
                    <option value="AD">AD</option>
                    <option value="AE">AE</option>
                    <option value="BCD">BCD</option>
                    <option value="ABCD">ABCD</option>
                    <option value="ABCE">ABCE</option>
                    <option value="ABDE">ABDE</option>
                    <option value="ACDE">ACDE</option>
                    <option value="BCDE">BCDE</option>
                    <option value="ABCDE">ABCDE</option>
                  </select>


                  {categoriaError && (

                    <div className="invalid-feedback">
                      {categoriaError}
                    </div>

                  )}

                </div>


                {/* =================================================
                  VENCIMENTO CNH
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">
                    Vencimento da CNH
                  </label>

                  <div className="custom-date-wrapper">

                    <DatePicker
                      locale={ptBR}

                      placeholderText="DD/MM/AAAA"

                      minDate={new Date()}

                      popperPlacement="bottom-start"

                      portalId="root"

                      selected={
                        form.data_vencimento
                          ? new Date(
                            `${form.data_vencimento}T00:00:00`
                          )
                          : null
                      }

                      onChange={(date) => {

                        if (!date) {

                          handleChange({
                            target: {
                              name: "data_vencimento",
                              value: "",
                            },
                          });

                          setDataVencimentoError("");

                          return;
                        }

                        const ano =
                          date.getFullYear();

                        const mes =
                          String(
                            date.getMonth() + 1
                          ).padStart(2, "0");

                        const dia =
                          String(
                            date.getDate()
                          ).padStart(2, "0");

                        const dataFormatada =
                          `${ano}-${mes}-${dia}`;


                        /* ==========================================
                           ATUALIZA FORM
                        ========================================== */

                        handleChange({
                          target: {
                            name: "data_vencimento",
                            value: dataFormatada,
                          },
                        });


                        /* ==========================================
                           VALIDA VENCIMENTO
                        ========================================== */

                        const hoje =
                          new Date();

                        hoje.setHours(
                          0,
                          0,
                          0,
                          0
                        );

                        const selecionada =
                          new Date(
                            `${dataFormatada}T00:00:00`
                          );

                        selecionada.setHours(
                          0,
                          0,
                          0,
                          0
                        );


                        if (
                          selecionada <= hoje
                        ) {

                          setDataVencimentoError(
                            "CNH vencida"
                          );

                        } else {

                          setDataVencimentoError("");

                        }


                        /* ==========================================
                           LOCAL STORAGE
                        ========================================== */

                        const userId =
                          localStorage.getItem("ID");

                        if (userId) {

                          localStorage.setItem(
                            `data_vencimento${userId}`,
                            dataFormatada
                          );

                        }

                      }}

                      dateFormat="dd/MM/yyyy"

                      showMonthDropdown

                      showYearDropdown

                      dropdownMode="select"

                      autoComplete="off"

                      customInput={
                        <InputMask
                          mask="99/99/9999"
                          placeholder="DD/MM/AAAA"
                          className={`cadastro-input custom-date-input ${dataVencimentoError
                              ? "cadastro-input-error"
                              : ""
                            }`}
                          autoComplete="off"
                          spellCheck={false}
                        />
                      }

                    />

                    <FiCalendar className="custom-date-icon" />

                  </div>


                  {dataVencimentoError && (

                    <div className="invalid-feedback">
                      {dataVencimentoError}
                    </div>

                  )}

                </div>


                {/* =================================================
                  NÚMERO DO ACESSO
              ================================================= */}

                <div className="cadastro-field">

                  <label className="cadastro-label">

                    Número do acesso

                    <span className="required">
                      *
                    </span>

                  </label>

                  <input
                    type="text"
                    name="access_code"
                    id="motorista_access_code"
                    placeholder="Apenas números"
                    inputMode="numeric"
                    maxLength={10}
                    required
                    autoComplete="off"
                    spellCheck={false}
                    className="cadastro-input"
                    value={
                      form.num_cartao_acesso || ""
                    }
                    onChange={(e) => {

                      const onlyNums =
                        e.target.value.replace(
                          /\D/g,
                          ""
                        );

                      const limited =
                        onlyNums.slice(0, 10);

                      handleChange({
                        target: {
                          name:
                            "num_cartao_acesso",
                          value: limited,
                        },
                      });

                    }}
                  />

                </div>

              </div>


              {/* =====================================================
                FOOTER / BOTÕES
            ===================================================== */}

              <div className="cadastro-enfermeiro-footer">

                <button
                  type="button"
                  className="
                  cadastro-btn
                  cadastro-btn-cancelar
                "
                  onClick={() =>
                    voltar("/maps/motorista")
                  }
                >
                  Cancelar
                </button>


                <button
                  type="submit"
                  className="
                  cadastro-btn
                  cadastro-btn-salvar
                "
                  disabled={!canSubmit}
                >
                  Cadastrar
                </button>

              </div>

            </form>

          </div>

        </div>

      </div>
    </>
  );
}

export default Cadastro_motorista;